module.exports = __webpack_public_path__ + "img/woman_icon.45f58852.png";